type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'Promoter'
const nameSource = 'partnerships/agencies'
const namePageTitle = 'Agencies'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Agencies',
  to: '/partnerships/agencies',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/partnerships/agencies/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/partnerships/agencies/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/partnerships/agencies/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export enum AGENCY_PARTNERSHIP_TYPE_ENUM {
  INDICATOR = 'indicator',
  OPERATOR = 'operator',
  HYBRID = 'hybrid'
}

export const AGENCY_PARTNERSHIP_TYPE_MAP: Record<
  AGENCY_PARTNERSHIP_TYPE_ENUM,
  string
> = {
  indicator: 'Agencia Indicadora',
  operator: 'Agencia Operadora',
  hybrid: 'Agencia Hibrida'
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
